import { Injectable } from '@angular/core';
import { BaseItemModelService } from './base-item.model';
import { TemplateControlType } from './types/template-control-type';
import { FiDocumentTemplateItemViewImageComponent } from '../document-template/document-template-item-view/document-template-item-view-image.component';
import { FiDocumentTemplateItemOptionsImageComponent } from '../document-template/document-template-item-options/document-template-item-options-image/document-template-item-options-image.component';
import { TemplatePlaceHolderControlModel } from '@fi-app/template/template-placeholder-control.model';

@Injectable()
export class ImageItemModelService {
    private imageItem: BaseItemModelService;
    model: TemplatePlaceHolderControlModel;
    config: any;

    constructor(baseItemModelService: BaseItemModelService) {
        this.imageItem = Object.create(baseItemModelService);

        this.imageItem.init(
            'image',
            TemplateControlType.Image,
            FiDocumentTemplateItemViewImageComponent,
            FiDocumentTemplateItemOptionsImageComponent,
            'templateItem.media.name',
            'pictureCcmIcon',
        );

        Object.assign(this, this.imageItem);
    }

    IsEmpty(contentLanguageId: number) {
        const content = this.model.Contents.find((c) => c.ContentLanguageId === contentLanguageId);
        if (!content) return true;

        if (content.Value.File && content.Value.File.Url) {
            return false;
        }

        if (
            this.model.Settings &&
            this.model.Settings.Columns == this.config.COLUMNS.TWO.id &&
            content.Value.additionalFile &&
            content.Value.additionalFile.Url
        ) {
            return false;
        }

        return true;
    }

    create() {
        return this.imageItem.create.call(this.imageItem);
    }
}
